import * as React from 'react';
const { useMemo, useCallback } = React;

import Divider from '../divider';
import Typography from '../typography';
import Menu from '../menu';
import Icon from '../icon';
import Button from '../button';
import ScrollableView from '../scrollable-view';
import CloseButton from '../close-button';
import {
	Root,
	IconLayout,
	Counter,
	HeaderLayout,
	CloseControl,
	FooterLayout,
	ContentLayout,
	ItemLayout,
	CloseButtonLayout,
} from './styled';


export type NotificationCenterProps<T> = {
	items: Array<T>;
	renderItem: (item: T) => React.ReactNode;
	onShowAll?: (e: React.SyntheticEvent) => void;
	onCloseItem?: (e: React.SyntheticEvent, item: T) => void;
}

export type NotificationCenterComponent<T = any> = React.SFC<NotificationCenterProps<T>>

const NotificationCenter: NotificationCenterComponent = (props) => {
	const {
		items,
		renderItem,
		onShowAll,
		onCloseItem,
	} = props;

	const handleShowAll = useCallback((close) => (e) => {
		onShowAll(e);
		close(e);
	}, [onShowAll]);

	const renderTrigger = useMemo(() => () => {
		const count = items.length;
		const notifyCount = count > 0
			? count < 10
				? count + ''
				: '9+'
			: '';
		const needRenderCounter = Boolean(notifyCount);
		
		return (
			<Root>
				<IconLayout>
					<Icon type='notification' color='muted' />
					{needRenderCounter && <Counter>{notifyCount}</Counter>}
				</IconLayout>
			</Root>
		);
	}, []);

	const handleCloseItem = useCallback((item) => (e) => onCloseItem(e, item), [onCloseItem]);

	return (
		<Menu.Base trigger={renderTrigger()} maxHeight={600}>
			{
				({ handleClose }) => (
					<Menu.List>
						<HeaderLayout>
							<Typography.Text fontWeight={700}>Уведомления</Typography.Text>
							<CloseControl onClick={handleClose}>Отметить все как прочитанные</CloseControl>
						</HeaderLayout>
						<Divider margin='small' />
						<ScrollableView style={{ height: 400 }}>
							<ContentLayout>
								{items.map((item, idx) => {
									return (
										<ItemLayout key={idx}>
											{
												typeof onCloseItem === 'function' && 
												<CloseButtonLayout>
													<CloseButton onClick={handleCloseItem(item)} />
												</CloseButtonLayout>
											}
											{renderItem(item)}
											<Divider margin='small' />
										</ItemLayout>
									)
								})}
							</ContentLayout>
						</ScrollableView>
						{
							typeof onShowAll === 'function' &&
							<React.Fragment>
								<Divider margin='small' />
								<FooterLayout>
									<Button onClick={handleShowAll(handleClose)}>Показать все</Button>
								</FooterLayout>
							</React.Fragment>
						}
					</Menu.List>
				)
			}
		</Menu.Base>
	);
}

NotificationCenter.displayName = 'NotificationCenter';
NotificationCenter.defaultProps = {
	items: [],
	renderItem: () => null,
};

export default NotificationCenter;
